// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__lLy_1","content":"error_content__Scqj2","buttons":"error_buttons__HdI46","secondary":"error_secondary__nj2YT","text":"error_text__K9_Dl"};